import React, { useEffect, useState } from "react";
import img_usr from "../../../assets/images/personal_info/img_usr.png";
import "./PersonalInfo.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const PersonalInfo = () => {
  const [data, setData] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("salsa");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const languageList = [
    { id: 0, language_name: "DE" },
    { id: 1, language_name: "EN" }
  ];
  const [selectedLanguageId, setSelectedLanguageId] = useState(0);
  const [languageToogle, setLanguageToogle] = useState(false);
  const [languageToogleValue, setLanguageToogleValue] = useState("DE");
  const [courseOrgNotification, setCourseOrgNotification] = useState(true);

  const getdata = async () => {
    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const login_action_user_type = localStorage.getItem("session_school_login_type");
    const api = `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=getlogininfo&user_id=${login_user_id}&action_type=${login_action_user_type}&status=1`;

    await axios.post(api).then((resp) => {
      setData(resp.data);
      setFirstName(resp?.data?.user_firstname);
      setLastName(resp?.data?.user_lastname);
      setEmail(resp?.data?.user_email);
      setAddress(resp?.data?.user_address);
      setPhone(resp?.data?.user_contact);
      setSelectedImage(resp?.data?.user_profile_pic || img_usr);
      setSelectedLanguageId(resp?.data?.student_language || 0);
      setCourseOrgNotification(resp?.data?.course_org_notification === "1");

      // Set language from API response or default to English
      const userLanguageId = resp?.data?.student_language;
      if (userLanguageId !== undefined && userLanguageId !== null) {
        setSelectedLanguageId(userLanguageId);
        const selectedLang = languageList.find(lang => lang.id === Number(userLanguageId));
        setLanguageToogleValue(selectedLang ? selectedLang.language_name : "DE");
      } else {
        // Default to English if no language is set
        setSelectedLanguageId(0);
        setLanguageToogleValue("DE");
      }
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const login_cookie = localStorage.getItem("session_user_login_cookie");
    const login_user_id = localStorage.getItem("session_user_id");
    const login_action_type = localStorage.getItem("session_user_type");
    const login_action_user_type = localStorage.getItem("session_school_login_type");
    const schoolId = localStorage.getItem("session_school_id");

    const api = `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=${login_cookie}&login_user_id=${login_user_id}&login_action_type=${login_action_type}&f=updateProfileInfo&user_id=${login_user_id}&action_type=${login_action_user_type}&status=1&first_name=${encodeURIComponent(firstName)}&last_name=${encodeURIComponent(lastName)}&address=${encodeURIComponent(address)}&school_id=${schoolId}&student_language=${selectedLanguageId}&course_org_notification=${courseOrgNotification ? 1 : 0}`;


    const formData = new FormData();

    if (selectedImage) {
      formData.append("image", selectedImage);
    }

    try {
      const resp = await axios.post(api, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (resp?.data?.status) {
        toast("Profile updated successfully");
        getdata();
      } else {
        toast("Failed to update profile");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Something went wrong while updating the profile.");
    }
  };

  useEffect(() => {
    getdata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="personal_info_section">
      <div className="container-fluid">
        <div className="personal_info_title">
          <h2>PERSONAL INFO</h2>
        </div>
        <div className="personal_info_card">
          <div className="personal_info_card_inner">
            <div className="info_name_img">
              <div className="info_img">
                <label className="input-group-text" htmlFor="inputGroupFile01">
                  <img
                    className="img-fluid"
                    src={selectedImage}
                    alt="USER"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = img_usr; // Fallback image
                    }}
                  />
                </label>
                <input
                  type="file"
                  className="form-control d-none"
                  id="inputGroupFile01"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      setSelectedImage(e.target.files[0]);
                    }
                  }}
                />
              </div>
              <div className="info_name d-md-block d-sm-none">
                <h3 className="text-uppercase">
                  {data?.user_firstname || " "} {data?.user_lastname || " "}
                </h3>
              </div>
            </div>
            <div className="info_form">
              <form className="row" onSubmit={submitForm}>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label htmlFor="inputFirstname" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputFirstname"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                  />
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label htmlFor="inputLastname" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputLastname"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.target.value);
                    }}
                  />
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label htmlFor="inputEmail" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="inputEmail"
                    placeholder=""
                    value={email}
                    readOnly
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label htmlFor="inputPassword" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="inputPassword"
                    placeholder="***********"
                    value={password}
                    readOnly
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label htmlFor="inputPhone" className="form-label">
                    Phone no
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="inputPhone"
                    placeholder=""
                    value={phone}
                    readOnly
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                  />
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label htmlFor="inputStudentCourse" className="form-label">
                    Prefered Language
                  </label>
                  <div className="type-select">
                    <button
                      className={`btn dropdown-toggle4 ${languageToogle && "show"}`}
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onClick={() => {
                        setLanguageToogle(!languageToogle);
                      }}
                    >
                      {languageToogleValue || "DE"}
                    </button>
                    <ul className={`dropdown-menu ${languageToogle && "show"}`}>
                      {languageList?.length > 0 ? (
                        languageList
                          .filter(item => Number(item.id) !== Number(selectedLanguageId))
                          .map((item, index) => (
                            <li key={index}>
                              <Link
                                className="dropdown-item"
                                href="#"
                                onClick={() => {
                                  setLanguageToogle(false);
                                  setLanguageToogleValue(item?.language_name);
                                  setSelectedLanguageId(item?.id); // Set the selected language ID
                                }}
                              >
                                {item?.language_name || ""}
                              </Link>
                            </li>
                          ))
                      ) : (
                        <li className="dropdown-item">No options</li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label className="form-label">
                    Course Organization Notification
                  </label>

                  <div className="d-flex align-items-center gap-4">

                    {/* YES Radio */}
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="courseOrgNotification"
                        id="courseOrgYes"
                        value="1"
                        checked={courseOrgNotification === true}
                        onChange={() => setCourseOrgNotification(true)}
                      />
                      <label className="form-check-label" htmlFor="courseOrgYes">
                        Yes
                      </label>
                    </div>

                    {/* NO Radio */}
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="courseOrgNotification"
                        id="courseOrgNo"
                        value="0"
                        checked={courseOrgNotification === false}
                        onChange={() => setCourseOrgNotification(false)}
                      />
                      <label className="form-check-label" htmlFor="courseOrgNo">
                        No
                      </label>
                    </div>

                  </div>
                </div>

                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label htmlFor="inputAddress" className="form-label">
                    Address
                  </label>
                  <textarea
                    className="form-control"
                    id="inputAddress"
                    rows="4"
                    placeholder="Lorem Ipsum has been the industry's standard dummy text ever since the when an unknown printer took."
                    value={address}
                    onChange={(e) => {
                      setAddress(e.target.value);
                    }}
                  ></textarea>
                </div>
                <button type="submit" className="btn btn_primary">
                  UPDATE
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
